const cookieGR = {
  title: "Πολιτική Cookies",
  effectiveDate: "24 Μαΐου 2026",
  intro: `Στο Agapaé δίνουμε ιδιαίτερη σημασία στη διαφάνεια ως προς τις τεχνολογίες που χρησιμοποιούμε στην Πλατφόρμα μας. Η παρούσα Πολιτική για τα Cookies σας ενημερώνει για τα cookies και τις παρεμφερείς τεχνολογίες που χρησιμοποιούμε, για ποιον λόγο τα χρησιμοποιούμε και πώς μπορείτε να διαχειριστείτε τις προτιμήσεις σας.

Η χρήση cookies από την Πλατφόρμα διέπεται από τον Ν. 3471/2006 (όπως ισχύει), τον Γενικό Κανονισμό Προστασίας Δεδομένων (ΕΕ) 2016/679 (GDPR) και την Οδηγία 2/2020 της Αρχής Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (ΑΠΔΠΧ).

Η παρούσα πολιτική πρέπει να διαβάζεται σε συνδυασμό με την Πολιτική Απορρήτου μας, η οποία παρέχει περαιτέρω λεπτομέρειες σχετικά με την επεξεργασία των προσωπικών σας δεδομένων.`,

  sections: [
    {
      heading: "1. Τι Είναι τα Cookies;",
      content: [
        `Τα cookies είναι μικρά αρχεία κειμένου που αποθηκεύονται στη συσκευή σας (υπολογιστή, ταμπλέτα ή κινητή συσκευή) όταν επισκέπτεστε έναν ιστότοπο. Χρησιμοποιούνται ευρέως για την ορθή λειτουργία των ιστοτόπων, τη βελτίωση της εμπειρίας του χρήστη και την ενημέρωση των διαχειριστών τους. Ορισμένα cookies, ανάλογα με τη χρήση τους, ενδέχεται να συνιστούν επεξεργασία προσωπικών δεδομένων κατά την έννοια του GDPR.`,
        `Πέραν των cookies, οι ιστότοποι ενδέχεται να χρησιμοποιούν και την τοπική αποθήκευση (local storage) — έναν παρεμφερή μηχανισμό που επιτρέπει την αποθήκευση δεδομένων στο πρόγραμμα περιήγησής σας. Σε αντίθεση με τα cookies, τα δεδομένα της τοπικής αποθήκευσης δεν αποστέλλονται στον διακομιστή με κάθε αίτηση προς τον ιστότοπο.`,
      ],
    },
    {
      heading: "2. Cookies που Χρησιμοποιούμε",
      content: [
        `Χρησιμοποιούμε ελάχιστο αριθμό cookies, εστιασμένα αποκλειστικά στη βασική λειτουργικότητα της Πλατφόρμας. Δεν χρησιμοποιούμε cookies διαφήμισης ή μάρκετινγκ.`,
        {
          type: "table",
          headers: [
            "Όνομα Cookie",
            "Πάροχος",
            "Σκοπός",
            "Κατηγορία",
            "Διάρκεια",
          ],
          rows: [
            [
              "agapae-consent",
              "Agapaé (πρώτου μέρους)",
              "Αποθηκεύει τις προτιμήσεις σας ως προς τη συγκατάθεση για τα cookies, ώστε να διατηρούνται μεταξύ επισκέψεων και υποτομέων",
              "Απαραίτητο",
              "1 έτος",
            ],
          ],
        },
      ],
    },
    {
      heading: "3. Τοπική Αποθήκευση που Χρησιμοποιούμε",
      content: [
        `Για λόγους διαφάνειας, δηλώνουμε επίσης τα ακόλουθα δεδομένα που αποθηκεύονται τοπικά στο πρόγραμμα περιήγησής σας. Είναι απαραίτητα για τη λειτουργία της Πλατφόρμας και δεν διαβιβάζονται σε τρίτα μέρη για διαφημιστικούς ή αναλυτικούς σκοπούς:`,
        {
          type: "table",
          headers: ["Κλειδί", "Σκοπός", "Κατηγορία"],
          rows: [
            [
              "wedding_token",
              "Αποθηκεύει το token ελέγχου ταυτότητας ώστε να παραμένετε συνδεδεμένοι",
              "Απαραίτητο",
            ],
            [
              "wedding_refresh_token",
              "Εξασφαλίζει τη συνέχεια της συνεδρίας σας ώστε να μη χρειάζεται να συνδέεστε επανειλημμένα",
              "Απαραίτητο",
            ],
            [
              "session_user",
              "Αποθηκεύει τα δεδομένα της συνεδρίας του χρήστη για την τρέχουσα σύνδεση",
              "Απαραίτητο",
            ],
          ],
        },
        `Τα παραπάνω δεδομένα ελέγχου ταυτότητας διαγράφονται κατά την αποσύνδεσή σας από την Πλατφόρμα.`,
        `Επιπλέον, η Πλατφόρμα αποθηκεύει ορισμένα λειτουργικά δεδομένα στην τοπική αποθήκευση και στην αποθήκευση συνεδρίας του προγράμματος περιήγησής σας, ώστε να διατηρούνται οι προτιμήσεις διεπαφής σας και να υποστηρίζονται καθημερινές ροές χρήσης. Περιλαμβάνονται, ενδεικτικά, η προτίμηση γλώσσας, οι ρυθμίσεις πλοήγησης και θέματος, καθώς και προσωρινές ενδείξεις κατάστασης που βοηθούν την Πλατφόρμα να ανακάμψει από επαναφορτώσεις σελίδας ή να διατηρήσει το σημείο στο οποίο βρισκόσασταν εντός μιας ροής. Τα δεδομένα αυτά είναι αποκλειστικά πρώτου μέρους, δεν διαβιβάζονται ποτέ σε τρίτους και μπορούν να αφαιρεθούν ανά πάσα στιγμή μέσω εκκαθάρισης των δεδομένων του Agapaé από το πρόγραμμα περιήγησής σας.`,
      ],
    },
    {
      heading: "4. Κατηγορίες Cookies",
      content: [
        {
          type: "emphasis",
          text: "Απαραίτητα Cookies (Πάντα Ενεργά)",
        },
        `Τα συγκεκριμένα cookies και δεδομένα αποθήκευσης είναι αυστηρώς αναγκαία για τη λειτουργία της Πλατφόρμας. Υποστηρίζουν βασικές λειτουργίες όπως ο έλεγχος ταυτότητας του χρήστη και η διαχείριση της συγκατάθεσής σας. Σύμφωνα με το άρθρο 4§5 του Ν. 3471/2006, ως αυστηρώς αναγκαία, δεν απαιτείται η συγκατάθεσή σας για τη χρήση τους και δεν μπορούν να απενεργοποιηθούν χωρίς να επηρεαστεί η λειτουργικότητα της Πλατφόρμας.`,
        {
          type: "emphasis",
          text: "Cookies Ανάλυσης",
        },
        `Προς το παρόν δεν χρησιμοποιούμε cookies ανάλυσης ή scripts παρακολούθησης (όπως Google Analytics, Mixpanel ή παρεμφερείς υπηρεσίες). Εάν στο μέλλον εισαχθούν αναλυτικά εργαλεία, θα επικαιροποιήσουμε την παρούσα πολιτική και θα ζητήσουμε τη συγκατάθεσή σας πριν από την ενεργοποίηση οποιουδήποτε σχετικού cookie.`,
        {
          type: "emphasis",
          text: "Cookies Μάρκετινγκ",
        },
        `Δεν χρησιμοποιούμε cookies μάρκετινγκ ή διαφήμισης. Δεν προβάλλουμε στοχευμένες διαφημίσεις και δεν χρησιμοποιούμε εικονοστοιχεία παρακολούθησης (tracking pixels), όπως αυτά της Meta (Facebook Pixel) ή της Google Ads. Η δραστηριότητα περιήγησής σας στο Agapaé δεν παρακολουθείται για διαφημιστικούς σκοπούς.`,
      ],
    },
    {
      heading: "5. Cookies και Scripts Τρίτων",
      content: [
        `Η Πλατφόρμα φορτώνει γραμματοσειρές από την υπηρεσία Google Fonts. Όταν το πρόγραμμα περιήγησής σας ζητά αρχεία γραμματοσειρών, η Google λαμβάνει τη διεύθυνση IP σας ως μέρος της τυπικής αίτησης δικτύου. Η υπηρεσία Google Fonts δεν τοποθετεί cookies παρακολούθησης στη συσκευή σας.`,
        `Ο πάροχος υπηρεσιών πληρωμών μας, η Stripe, ενδέχεται να τοποθετήσει cookies στον δικό της τομέα κατά την αλληλεπίδρασή σας με τη διεπαφή πληρωμής. Τα cookies αυτά διέπονται από τη δική της πολιτική για τα cookies και είναι απαραίτητα για την ασφαλή διεκπεραίωση των πληρωμών.`,
        {
          type: "emphasis",
          text: "Sentry (Παρακολούθηση Σφαλμάτων και Απόδοσης)",
        },
        `Χρησιμοποιούμε την υπηρεσία Sentry (της εταιρείας Functional Software, Inc.) για τον εντοπισμό, τη διάγνωση και τη διόρθωση σφαλμάτων και ζητημάτων απόδοσης της Πλατφόρμας. Το SDK του Sentry εκτελείται στο πρόγραμμα περιήγησής σας, δεν τοποθετεί cookies και αποστέλλει αναφορές σφαλμάτων και απόδοσης προς το Sentry μέσω κρυπτογραφημένης σύνδεσης HTTPS. Οι αναφορές αυτές περιλαμβάνουν τη διεύθυνση IP σας, χαρακτηριστικά του προγράμματος περιήγησης και της συσκευής σας, τη σελίδα στην οποία σημειώθηκε το πρόβλημα και, εφόσον είστε συνδεδεμένοι, το αναγνωριστικό του λογαριασμού σας. Η χρήση του Sentry εξυπηρετεί αποκλειστικά τη λειτουργική αξιοπιστία της Πλατφόρμας και δεν αξιοποιείται για αναλυτικά εργαλεία, profiling ή διαφήμιση. Οι διεθνείς διαβιβάσεις δεδομένων προς το Sentry διέπονται από τις Τυποποιημένες Συμβατικές Ρήτρες (SCCs) της Ευρωπαϊκής Επιτροπής· περισσότερες λεπτομέρειες παρέχονται στην Πολιτική Απορρήτου μας.`,
        {
          type: "emphasis",
          text: "Cloudflare Turnstile (Προστασία από Αυτοματοποιημένα Προγράμματα)",
        },
        `Χρησιμοποιούμε την υπηρεσία Cloudflare Turnstile για την προστασία των φορμών εγγραφής, σύνδεσης, RSVP και επικοινωνίας από αυτοματοποιημένη κατάχρηση. Το widget του Turnstile φορτώνεται από τον τομέα "challenges.cloudflare.com" και ενδέχεται να αποθηκεύσει μικρές πληροφορίες προστασίας από bots στον δικό της τομέα της Cloudflare (όχι στο agapae.gr). Οι πληροφορίες αυτές χρησιμοποιούνται αποκλειστικά για τη διάκριση μεταξύ ανθρώπων και αυτοματοποιημένων προγραμμάτων και δεν αξιοποιούνται για διαφημιστικούς σκοπούς ή για παρακολούθηση μεταξύ ιστοτόπων. Οι διεθνείς διαβιβάσεις δεδομένων διέπονται από τις Τυποποιημένες Συμβατικές Ρήτρες (SCCs) της Ευρωπαϊκής Επιτροπής.`,
        `Πέραν των Google Fonts, Stripe, Sentry και Cloudflare Turnstile που περιγράφονται παραπάνω, δεν ενσωματώνουμε widgets κοινωνικών δικτύων, scripts διαφήμισης ή εργαλεία παρακολούθησης για αναλυτικούς ή διαφημιστικούς σκοπούς στην Πλατφόρμα μας.`,
      ],
    },
    {
      heading: "6. Διαχείριση Προτιμήσεων Cookies",
      content: [
        `Κατά την πρώτη επίσκεψή σας στην Πλατφόρμα, εμφανίζεται ένα banner συγκατάθεσης για τα cookies που σας δίνει τη δυνατότητα να:`,
        {
          type: "list",
          items: [
            `Αποδεχθείτε όλα τα cookies·`,
            `Απορρίψετε τα μη αναγκαία cookies (θα χρησιμοποιηθούν μόνο τα αυστηρώς αναγκαία cookies).`,
          ],
        },
        `Επειδή προς το παρόν δεν χρησιμοποιούμε μη αναγκαία cookies, το πρακτικό αποτέλεσμα και των δύο επιλογών είναι το ίδιο — η επιλογή σας ωστόσο καταγράφεται, ώστε εάν στο μέλλον εισαχθούν μη αναγκαίες κατηγορίες cookies, η υπάρχουσα προτίμησή σας να γίνει σεβαστή.`,
        `Η προτίμηση συγκατάθεσής σας αποθηκεύεται στο cookie "agapae-consent" και ισχύει σε όλους τους υποτομείς του Agapaé (agapae.gr, app.agapae.gr, invite.agapae.gr), ώστε να χρειαστεί να ορίσετε την προτίμησή σας μόνο μία φορά.`,
      ],
    },
    {
      heading: "7. Ανάκληση Συγκατάθεσης",
      content: [
        `Σύμφωνα με το άρθρο 7§3 του Γενικού Κανονισμού Προστασίας Δεδομένων (GDPR), μπορείτε να μεταβάλετε ή να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή, μέσω των ακόλουθων μεθόδων:`,
        {
          type: "list",
          items: [
            `Διαγράψτε τα cookies του προγράμματος περιήγησής σας για το agapae.gr — το banner συγκατάθεσης θα εμφανιστεί εκ νέου κατά την επόμενη επίσκεψή σας, επιτρέποντάς σας να κάνετε νέα επιλογή·`,
            `Χρησιμοποιήστε τις ενσωματωμένες ρυθμίσεις διαχείρισης cookies του προγράμματος περιήγησής σας για να διαγράψετε ειδικά το cookie "agapae-consent".`,
          ],
        },
        {
          type: "emphasis",
          text: "Ρυθμίσεις Προγράμματος Περιήγησης",
        },
        `Τα περισσότερα προγράμματα περιήγησης σας επιτρέπουν να ελέγχετε τα cookies μέσα από τις ρυθμίσεις τους. Οι σχετικές επιλογές βρίσκονται συνήθως στην ενότητα "Απόρρητο" ή "Ασφάλεια" των προτιμήσεων του προγράμματος περιήγησης. Επισημαίνεται ότι ο αποκλεισμός όλων των cookies ενδέχεται να επηρεάσει τη λειτουργικότητα της Πλατφόρμας, ιδίως τον έλεγχο ταυτότητας.`,
      ],
    },
    {
      heading: "8. Αλλαγές στην Πολιτική Cookies",
      content: [
        `Ενδέχεται να επικαιροποιήσουμε την παρούσα Πολιτική για τα Cookies, προκειμένου να αντικατοπτρίζονται αλλαγές στις πρακτικές μας ή για λοιπούς λειτουργικούς, νομικούς ή ρυθμιστικούς λόγους. Σε περίπτωση αλλαγών, θα ενημερώσουμε την «Ημερομηνία ισχύος» στην αρχή της πολιτικής.`,
        `Σε περίπτωση εισαγωγής νέων κατηγοριών cookies (όπως αναλυτικών εργαλείων ή εργαλείων μάρκετινγκ), θα σας ενημερώσουμε σχετικά και θα λάβουμε τη συγκατάθεσή σας πριν από την ενεργοποίησή τους.`,
      ],
    },
    {
      heading: "9. Επικοινωνία",
      content: [
        `Εάν έχετε ερωτήσεις σχετικά με τη χρήση των cookies ή με την παρούσα πολιτική, μπορείτε να επικοινωνήσετε μαζί μας:`,
        {
          type: "list",
          items: [
            `Email: privacy@agapae.gr`,
            `Εταιρεία: EnQube ΙΚΕ`,
            `Έδρα: Πάτρα, Ελλάδα`,
          ],
        },
      ],
    },
  ],
};

export default cookieGR;
